import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  applicantApplicationsRoute,
  employerApplicationsKey,
  errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type UseGetApplicantApplicationsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
  id?: number | null;
  isCompany?: boolean
};

export const useGetApplicantApplications = ({
  setErrorText = () => { },
  id,
  isCompany
}: UseGetApplicantApplicationsProps) => {
  const { data: applicantApplicationsData } = useQuery({
    queryKey: [employerApplicationsKey, id],
    queryFn: () => {
      const params = new URLSearchParams();

      params.append('applicant_id', String(id));

      return axiosInstance
        .get(applicantApplicationsRoute, { params })
        .then((res) => res.data);
    },
    onSuccess: (data) => {
      if (data.object) {
        setErrorText('');
      }
    },
    onError: () => {
      setErrorText(errorMessage);
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(id && isCompany),
  });

  return {
    applicantApplicationsData,
  };
};
